// Entry point for the build script in your package.json

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "trix"
import "@rails/actiontext"
import "./outbound_spoonflower"
import "./parallax"
import "./controllers"
import "./direct_upload"
